import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isH5pEditorFrame = window.location.pathname === "/h5p-editor-frame";

if (isH5pEditorFrame) {
  import("./components/H5P/h5pEditorFrame").then(({ default: H5pEditorFrame }) => {
    root.render(<H5pEditorFrame />);
  });
} else {
  import("./mainApp").then(({ mountMainApp }) => mountMainApp(root));
}
